<template>
  <div class="triggerContainer">
    <div class="triggerHeader"><span>Triggers  </span></div>

    <flow-diagram v-for="trigger in triggersTree " :key="trigger.id" :trigger="trigger"></flow-diagram>


  </div>
</template>

<script>
  import flowDiagram from '../flowDiagrame/flowDiagram'

  export default {
    name: "triggers",
    components: {flowDiagram},
    created() {

    },
    data() {
      return {
        //please make sure that the triggers  have the same structure as follow on the add Triggers component,
        triggersTree: [{
          device: {
            name: 'gateWay 1',
            id: '1',
            isGateWay: true,
          },
          conditions: [{deviceId: '1', operator: 'LastUpdate', id: '1c', value: 10, event: [{name: 'notify'}]}],
          children: [{
            device: {
              name: 'Thermostat',
              id: '1-1',
              isGateWay: false,
            },
            conditions: [{deviceId: '1-1', operator: 'Above', id: '2c', value: 24, event: [{name: 'Command'}]}],
          },
            {
              device: {
                name: 'Vibration',
                id: '1-2',
                isGateWay: false,
              },
              conditions: [{deviceId: '1-2', id: '3c', operator: 'Above', value: 20.0, event: [{name: 'Command'}]}],
            }]
        }]
      }
    }

  }


</script>

<style lang="scss" scoped>
  @import "../styles/variables";

  .triggerContainer {
    margin: 6px;
    height: 90%;

    .triggerHeader {
      background-color: $transparentWhite;
      height: 40px;
      display: flex;
      align-items: center;
      border-radius: 8px 8px 0 0;
      span {
        margin-left: 8px;
      }
      i {
        margin-left: auto;
        margin-right: 8px;
      }
    }

  }


</style>



// WEBPACK FOOTER //
// src/views/project/create-project/triggers/triggers.vue